import {
  caseInsensitiveProjectRouteMW,
  onRouteActivateMW,
  routerForOnlyLoggedUserMW,
} from './router-middlewares';
import type { RouterConfig } from './types';

export const desktopRouterConfig: RouterConfig = {
  defaultRoute: 'home',
  useHash: false,
  strictTrailingSlash: false,
  queryParamsMode: 'loose',
  middlewares: [routerForOnlyLoggedUserMW, caseInsensitiveProjectRouteMW, onRouteActivateMW],
};

export const FILTERING_QUERY_PARAMS =
  ':status&:searchTerm&:tags&:createDateRangeStart&:creationDateRangeEnd&:relativeTime&:owner';
export const COMPARE_QUERY_PARAMS = ':compare&:split&:dash';
